import { Capacitor } from "@capacitor/core";

/**
 * true quando o código roda dentro do APK, false no navegador.
 *
 * Fica num módulo próprio, e não no router, para qualquer parte do sistema
 * poder perguntar sem criar dependência circular com as rotas.
 *
 * A ponte do Capacitor registra o objeto que responde isto no WebView ANTES de
 * qualquer script da página, então avaliar no carregamento do módulo é seguro.
 */
export const NATIVO = Capacitor.isNativePlatform();
